import {HttpResponse, HttpService} from "./http.service";
import {PublisherApplicationModel} from "../models/publisher/publisher-application.model";

export const ApplicationService = {

    async contentDownloaded(id: string): Promise<HttpResponse<PublisherApplicationModel>> {
        const response: HttpResponse<PublisherApplicationModel> = await HttpService.post(`application/${id}/content/`, {});

        return response;
    },
    async reportDownloaded(id: string): Promise<HttpResponse<PublisherApplicationModel>> {
        const response: HttpResponse<PublisherApplicationModel> = await HttpService.post(`application/${id}/report/`, {});

        return response;
    },
    async addToBookmark(id: string): Promise<HttpResponse<PublisherApplicationModel>> {
        const response: HttpResponse<PublisherApplicationModel> = await HttpService.post(`application/${id}/bookmark/`, {});

        return response;
    },
    async publisherDoesntWantToPublish(id: string): Promise<HttpResponse<PublisherApplicationModel>> {
        const response: HttpResponse<PublisherApplicationModel> = await HttpService.post(`application/${id}/no_publish/`, {});

        return response;
    },
    async publisherWantToPublish(id: string): Promise<HttpResponse<PublisherApplicationModel>> {
        const response: HttpResponse<PublisherApplicationModel> = await HttpService.post(`application/${id}/publish/`, {});

        return response;
    },
    async success(id: string): Promise<HttpResponse<PublisherApplicationModel>> {
        const response: HttpResponse<PublisherApplicationModel> = await HttpService.post(`application/${id}/success/`, {});

        return response;
    },
    async fail(id: string): Promise<HttpResponse<PublisherApplicationModel>> {
        const response: HttpResponse<PublisherApplicationModel> = await HttpService.post(`application/${id}/fail/`, {});

        return response;
    },
    async authorDoesntWantToPublish(id: string): Promise<HttpResponse<PublisherApplicationModel>> {
        const response: HttpResponse<PublisherApplicationModel> = await HttpService.post(`application/${id}/reject/`, {});

        return response;
    },
    async authorWantToPublish(id: string): Promise<HttpResponse<PublisherApplicationModel>> {
        const response: HttpResponse<PublisherApplicationModel> = await HttpService.post(`application/${id}/accept/`, {});

        return response;
    }
}
